import { InstallationData, ISerialSubmission } from '@extendedWarranty/types/extendedWarranty';

/**
 * Function to check if for a given serial number its' counterpart duplicates have been resolved
 * @param installations Record of all installations, with their respective serial numbers
 * @param sn The serial number object
 * @returns False if there still exists unresolved duplicates, or true if no unresolved duplicates detected or if there isn't any duplicate.
 */
const areDuplicatesFixed = (installations: Record<string, InstallationData>, sn: ISerialSubmission) => {
    const duplicateErrorSNs = Object.keys(installations).reduce(
        (acc, curr) => [...acc, ...installations[curr].serial_numbers.filter((sn) => sn.isDuplicate)],
        [] as ISerialSubmission[]
    );

    return duplicateErrorSNs
        .filter((dsn) => dsn.SerialNumber === sn.SerialNumber && dsn.id !== sn.id)
        .every((dsn) => !!dsn.edit_value);
};

export { areDuplicatesFixed };
